import React, { Component } from 'react'
import classes from './elements.module.css'
import Icon from '../elements/Icon/Icon'
import UiColor from './UiColor'

export default class IconCurrency extends Component {
    render = () => {
        const { currencyCode, colorNotActive, style, checked } = this.props

        switch (currencyCode) {
            case 'ETH':
            case 'BTC':
            case 'LTC':
            case 'TRX':
            case 'DOGE':
            case 'XVG':
            case 'BSV':
            case 'BCH':
            case 'XRP':
            case 'XLM':
            case 'FIO':
            case 'ETC':
            case 'BNB_SMART':
            case 'TON':
                return (
                    <>
                        <div className={classes.currency__wrapper} style={{ borderColor: colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor[currencyCode] }}>
                            <Icon icon={currencyCode} size={24} color={colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor[currencyCode]} style={{ marginTop: 7, marginRight: 8 }} />
                        </div>
                    </>
                )
            case 'XMR':
                return (
                    <>
                        <div className={classes.currency__wrapper} style={{ borderColor: colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor[currencyCode] }}>
                            <Icon icon={currencyCode} size={24} color={colorNotActive ? colorNotActive : checked ? '#864DD9' : ''} style={{ marginTop: 7, marginRight: 8 }} />
                        </div>
                    </>
                )
            case 'USDT':
                return (
                    <>
                        <div className={classes.currency__wrapper} style={{ borderColor: colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor[currencyCode] }}>
                            <Icon icon={'USDT'} size={24} color={colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor['USDT']} style={{ marginTop: 7, marginRight: 8 }} />
                        </div>
                        <Icon icon={'BTC'} size={16} color={colorNotActive ? colorNotActive : UiColor['BTC']} className={classes.little__circle} />
                    </>
                )
            case 'ETH_USDT':
                return (
                    <>
                        <div className={classes.currency__wrapper} style={{ borderColor: colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor[currencyCode] }}>
                            <Icon icon={'USDT'} size={24} color={colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor['USDT']} style={{ marginTop: 7, marginRight: 8 }} />
                        </div>
                        <Icon icon={'ETH'} size={16} color={colorNotActive ? colorNotActive : UiColor['ETH']} className={classes.little__circle} />
                    </>
                )
            case 'TRX_BTT':
                return (
                    <>
                        <div className={classes.currency__wrapper} style={{ borderColor: colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor[currencyCode] }}>
                            <Icon icon={currencyCode} size={23} color={colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor[currencyCode]} style={{ marginTop: 8, marginRight: 8 }} />
                        </div>
                        <Icon icon={'TRX'} size={16} color={colorNotActive ? colorNotActive : UiColor['TRX']} className={classes.little__circle} />
                    </>
                )
            case 'TRX_USDT':
                return (
                    <>
                        <div className={classes.currency__wrapper} style={{ borderColor: colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor[currencyCode] }}>
                            <Icon icon={'USDT'} size={24} color={colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor['USDT']} style={{ marginTop: 7, marginRight: 8 }} />
                        </div>
                        <Icon icon={'TRX'} size={16} color={colorNotActive ? colorNotActive : UiColor['TRX']} className={classes.little__circle} />
                    </>
                )
            case 'ETH_TRUE_USD':
            case 'ETH_USDC':
            case 'ETH_PAX':
            case 'ETH_DAIM':
            case 'ETH_OKB':
            case 'ETH_MKR':
            case 'ETH_KNC':
            case 'ETH_BNT':
            case 'ETH_UNI':
            case 'ETH_ENJ':
            case 'ETH_AAVE':
            case 'ETH_BADGER':
            case 'ETH_CHZ':
            case 'ETH_CRO':
            case 'ETH_CRV':
            case 'ETH_GRT':
            case 'ETH_MATIC':
            case 'ETH_OMG':
            case 'ETH_RSR':
            case 'ETH_SNX':
            case 'ETH_YFI':
            case 'ETH_ZRX':
            case 'ETH_SXP':
            case 'ETH_LINK':
            case 'ETH_BAL':
            case 'ETH_COMP':
            case 'ETH_BUSD':
            case 'ETH_SHIB':
                return (
                    <>
                        <div className={classes.currency__wrapper} style={{ borderColor: colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor[currencyCode] }}>
                            <Icon icon={currencyCode} size={24} color={colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor[currencyCode]} style={{ marginTop: 7, marginRight: 8 }} />
                        </div>
                        <Icon icon={'ETH'} size={16} color={colorNotActive ? colorNotActive : UiColor['ETH']} className={classes.little__circle} />
                    </>
                )
            case 'BTG':
                return (
                    <>
                        <div className={classes.currency__wrapper} style={{ borderColor: colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor[currencyCode] }}>
                            <div className={classes.btg} style={{ borderColor: colorNotActive ? colorNotActive : checked ? '#B38BF0' : '#E1A600' }}>
                                <Icon icon={currencyCode} size={20} color={colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor[currencyCode]} style={style ? style : { marginTop: 0, marginLeft: 2 }} />
                            </div>
                        </div>
                    </>
                )
            case 'ETH_UAX':
                return (
                    <>
                        <div className={classes.currency__wrapper} style={{ borderColor: colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor[currencyCode] }}>
                            {colorNotActive || checked ?
                                <Icon icon={'ETH_UAX_SELECT'} color={colorNotActive ? colorNotActive : checked ? '#864DD9' : ''} size={24} style={{ marginTop: 7, marginRight: 8 }} />
                                : <Icon icon={currencyCode} size={24} style={{ marginTop: 7, marginRight: 8 }} />}
                        </div>
                        <Icon icon={'ETH'} size={16} color={colorNotActive ? colorNotActive : UiColor['ETH']} className={classes.little__circle} />
                    </>
                )
            case 'BNB':
                return (
                    <>
                        <div className={classes.currency__wrapper} style={{ borderColor: colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor['ETH_BNB'] }}>
                            <Icon icon={'ETH_BNB'} size={24} color={colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor['ETH_BNB']} style={{ marginTop: 7, marginRight: 8 }} />
                        </div>
                    </>
                )
            case 'ETH_BAT':
            case 'ETH_1INCH':
            case 'ETH_BTC':
            case 'ETH_HUOBI':
            case 'ETH_SUSHI':
                return (
                    <>
                        <div className={classes.currency__wrapper} style={{ borderColor: colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor[currencyCode] }}>
                            <Icon icon={currencyCode} size={24} color={colorNotActive ? colorNotActive : checked ? '#864DD9' : ''} style={{ marginTop: 7, marginRight: 8 }} />
                        </div>
                        <Icon icon={'ETH'} size={16} color={colorNotActive ? colorNotActive : UiColor['ETH']} className={classes.little__circle} />
                    </>
                )
            case 'BNB_SMART_ADA':
                return (
                    <>
                        <div className={classes.currency__wrapper} style={{ borderColor: colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor[currencyCode] }}>
                            <Icon icon={currencyCode} size={24} color={colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor[currencyCode]} style={{ marginTop: 7, marginRight: 8 }} />
                        </div>
                        <Icon icon='BNB_SMART' size={16} color={colorNotActive ? colorNotActive : UiColor['BNB_SMART']} className={classes.little__circle} />
                    </>
                )

            case 'UAH':
            case 'RUB':
            case 'USD':
            case 'KZT':
            case 'EUR':
            case 'GBP':
            case 'TRY':
            case 'AUD':
            case 'BGN':
            case 'BRL':
            case 'CAD':
            case 'CHF':
            case 'CNY':
            case 'COP':
            case 'CZK':
            case 'DKK':
            case 'DOP':
            case 'EGP':
            case 'HKD':
            case 'HRK':
            case 'IDR':
            case 'ILS':
            case 'JOD':
            case 'JPY':
            case 'KES':
            case 'KRW':
            case 'KWD':
            case 'LKR':
            case 'MAD':
            case 'MXN':
            case 'MYR':
            case 'NGN':
            case 'NOK':
            case 'NZD':
            case 'OMR':
            case 'PEN':
            case 'PKR':
            case 'PLN':
            case 'RON':
            case 'SEK':
            case 'SGD':
            case 'THB':
            case 'TWD':
            case 'VND':
            case 'ZAR':
                return (
                    <>
                        <div className={classes.currency__wrapper} style={{ borderColor: colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor[currencyCode] }}>
                            <Icon icon={currencyCode} size={24} color={colorNotActive ? colorNotActive : checked ? '#864DD9' : UiColor[currencyCode]} style={{ marginTop: 7, marginRight: 8 }} />
                        </div>
                    </>
                )

            default:
                return (
                    <>
                        <div className={classes.currency__wrapper} style={{ borderColor: colorNotActive ? colorNotActive : checked ? '#864DD9' : '#404040' }}>
                            <Icon icon={'FIAT_DEFAULT'} size={24} color={colorNotActive ? colorNotActive : checked ? '#864DD9' : '#404040'} style={{ marginTop: 7, marginRight: 8 }} />
                        </div>
                    </>
                )
        }
    }
}